<template>
  <div class="container-768">
    <div class="home-page pt-20">
      <div class="page-header">
        予約一覧
      </div>
      <div v-for="item in currentMeetings" :key="item.id" class="meeting-notice">
        <div>
          <span>{{item ? item.start_at : '' | meetingTimeDisplay(item ? item.end_at : '')}} の予約が開催期間中です </span>
          <router-link :to="{name: 'meetings.show', params: {id: item.id}}" class="btn-detail-list-meeting">詳細</router-link>
        </div>
      </div>
      <div class="meeting-page clearfix">

        <input id="meeting-categories-input" type="checkbox">
        <div class="meeting-categories closed">
          <label for="meeting-categories-input">
            <img src="../assets/icon/magnifuing-glass.png">
            絞り込み条件選択を開く
          </label>
        </div>
        <div class="meeting-categories">
          <div class="opened">
            <label for="meeting-categories-input">
              <span>[X] 閉じる</span>
            </label>
          </div>
          <div class="explanation-checkbox text-center pt-15 pb-15 pl-20 pr-20">
            一覧に表示する予約の種類を指定できます
          </div>
          <div class="item" v-for="category in categories" :key="category.id" @click="selectCategories(category.id)">
            <span class="check-box" :style="`border-color: ${category.color}; background-color:${category.color}`">
              <span v-show="searchParams && searchParams.categoryIds.findIndex(n => n === category.id) !== -1"></span>
            </span>
            <span class="label" :style="`color: ${category.color}`">{{category.name_kanji}}</span>
          </div>
        </div>

        <div class="meetings-list">
          <div class="meeting-list-filter">
            <el-row class="list-filter" style="float: left">
              <el-select @change="handleYearSelected" :value="searchParams.year" placeholder="2019年" class="select-filter">
                <el-option
                        v-for="item in listYearSelect"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                </el-option>
              </el-select>
              <el-select @change="handleMonthSelected" :value="searchParams.month"  placeholder="1月" class="narrow-select-filter">
                <el-option
                        v-for="item in listMonth"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                </el-option>
              </el-select>
            </el-row>

            <el-row class="list-filter" style="float: right">
              <el-select @change="handleStatusSelected" :value="searchParams.status" class="select-filter">
                <el-option
                        v-for="item in listStatus"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                </el-option>
              </el-select>
            </el-row>
          </div>

          <ListMeeting :month="selectedMonth" />

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import {mapActions, mapGetters} from 'vuex'
import {apiErrorDialog, getListYear, getMonths, getStatus} from '../helpers'
import ListMeeting from '@/components/meetings/ListMeeting'
import moment from 'moment'
import MeetingApi from '../api/meeting'
import {convert2LocalTime} from '@/helpers'

export default {
  components: {ListMeeting},
  data () {
    return {
      listYearSelect: [],
      listMonth: [],
      listStatus: [],
      currentMeetings: null,
      selectedMonth: null
    }
  },
  computed: {
    ...mapGetters({
      meetings: 'meetings/items',
      categories: 'meetings/categories',
      searchParams: 'meetings/searchParams'
    })
  },
  watch: {
    'categories': function (val) {
      if (val.length > 0) {
        this.searchParams.categoryIds = [-1, ...val.map(n => n.id)]
        let searchParams = this.searchParams
        searchParams.month = moment().month() + 1
        const callbacks = {error: (_error) => apiErrorDialog(this, _error)}
        this.fetchMeetingItems({params: searchParams, callbacks: callbacks})
      }
    }
  },
  methods: {
    getListYear,
    ...mapActions({
      fetchMeetingItems: 'meetings/fetchMeetings'
    }),
    async selectCategories (cateId) {
      const loading = this.$loading.show()
      let searchParams = this.searchParams
      const index = _.findIndex(searchParams.categoryIds, n => n === cateId)
      if (index === -1) {
        searchParams.categoryIds = [...searchParams.categoryIds, cateId]
      } else {
        _.remove(searchParams.categoryIds, n => n === cateId)
        searchParams.categoryIds = [...searchParams.categoryIds]
      }
      const callbacks = {error: (_error) => {
        loading.hide()
        apiErrorDialog(this, _error)
      }}
      await this.fetchMeetingItems({params: searchParams, callbacks: callbacks})
      loading.hide()
    },
    async handleYearSelected (val) {
      const loading = this.$loading.show()
      let searchParams = this.searchParams
      searchParams.year = val
      const callbacks = {error: (_error) => {
        loading.hide()
        apiErrorDialog(this, _error)
      }}
      await this.fetchMeetingItems({params: searchParams, callbacks: callbacks})
      loading.hide()
    },
    async handleMonthSelected (val) {
      const loading = this.$loading.show()
      let searchParams = this.searchParams
      this.selectedMonth = searchParams.month = val
      const callbacks = {error: (_error) => {
        loading.hide()
        apiErrorDialog(this, _error)
      }}
      await this.fetchMeetingItems({params: searchParams, callbacks: callbacks})
      loading.hide()
    },
    async handleStatusSelected (val) {
      const loading = this.$loading.show()
      let searchParams = this.searchParams
      searchParams.status = val
      const callbacks = {error: (_error) => {
        loading.hide()
        apiErrorDialog(this, _error)
      }}
      await this.fetchMeetingItems({params: searchParams, callbacks: callbacks})
      loading.hide()
    },
    async getCurrentMeeting () {
      const res = await MeetingApi.get({status: 'accepted', current: true})
      this.currentMeetings = res.data.data ? res.data.data : []
      const localTime = moment.tz.guess()
      for (let i = 0; i < this.currentMeetings.length; i++) {
        this.currentMeetings[i].start_at = convert2LocalTime(this.currentMeetings[i].start_at, localTime)
        this.currentMeetings[i].end_at = convert2LocalTime(this.currentMeetings[i].end_at, localTime)
      }
    }
  },
  async mounted () {
    this.searchParams.categoryIds = [-1, 1, 2, 3, 4, 5]
    this.selectedMonth = this.searchParams.month
    this.listYearSelect = getListYear(5)
    this.listMonth = getMonths()
    this.listStatus = getStatus()
    this.getCurrentMeeting()
    if (this.searchParams.status !== 'accepted') {
      let searchParams = this.searchParams
      searchParams.status = 'accepted'
      const callbacks = {error: (_error) => apiErrorDialog(this, _error)}
      await this.fetchMeetingItems({params: searchParams, callbacks: callbacks})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Home.vue